import { Reveal, CtaButton } from "./shared";
import { LogoMark } from "./Nav";

export const FinalCta = () => (
  <section className="relative bg-[#0B1B2B] overflow-hidden" data-testid="final-cta-section">
    <div className="absolute inset-0 dot-grid-dark pointer-events-none" />
    <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10 py-16 lg:py-24 text-center">
      <Reveal>
        <p className="text-[13px] uppercase tracking-[0.24em] font-bold text-[#7fd6b8]">Final Step</p>
        <h2 className="mt-6 font-display font-extrabold text-white tracking-[-0.03em] leading-[1.02] text-4xl sm:text-5xl lg:text-6xl max-w-[860px] mx-auto">
          See how this works across <span className="text-[#7fd6b8]">your portfolio.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mt-7 text-white/80 text-base md:text-lg leading-relaxed max-w-[640px] mx-auto">
          The presentation walks you through the five-pillar framework, the three portfolio cases,
          and the 90-day recovery methodology. Then you'll know whether it fits your next move.
        </p>
      </Reveal>
      <Reveal delay={0.22}>
        <div className="mt-10 flex justify-center">
          <CtaButton testId="final-cta-button" invert>Book a 20-minute Discovery call</CtaButton>
        </div>
        <div className="mt-8 flex flex-wrap justify-center items-center gap-x-5 gap-y-3 text-xl md:text-2xl font-display font-bold text-white/90 tracking-wide">
          <span>$25,000 fixed per company</span>
          <span className="w-2 h-2 rounded-full bg-[#7fd6b8]/70" />
          <span>7-day diagnostics</span>
          <span className="w-2 h-2 rounded-full bg-[#7fd6b8]/70" />
          <span>68% recovery rate</span>
        </div>
      </Reveal>
    </div>

    <footer className="relative border-t border-white/10" data-testid="footer">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-9 flex flex-col sm:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-3">
          <LogoMark className="w-7 h-7" />
          <span className="leading-none">
            <span className="block font-display font-extrabold tracking-[0.16em] text-[14px] text-white">SENIORS</span>
            <span className="block text-[12px] tracking-[0.02em] text-white/70 mt-[3px] font-semibold whitespace-nowrap">Capturing Trapped Value: Cash – Margin – Throughput</span>
          </span>
        </div>
        <p className="text-white/70 text-[12.5px]">
          © {new Date().getFullYear()} Seniors Implementation Consulting · Enterprise Value Intelligence™
        </p>
      </div>
    </footer>
  </section>
);
